import { gql } from '@apollo/client'

// Single source of truth for which RentalActions fields any rental query
// must fetch. Spread this fragment inside every `actions(...)` selection on
// Rental — forgetting any field makes downstream UI silently render the
// wrong branch.
export const FRAGMENT_RENTAL_ACTIONS = gql`
  fragment rentalActionFields on RentalActions {
    showExchangeAction
    showEarlyUpgradeAction
    showStandardUpgradeAction
    showLostOrStolenAction
    showReplaceBrokenDeviceAction
    showUpgradeAction
    showCancelAction
    showReturnAction
    showReassignDeviceAction
    showDeviceProlongingAction
    showPurchaseDeviceAction
    showRepairUpgradeAction
    showReplaceFromDepotAction
    showReplacementOrderFlow
    showDeviceSelectionForLostDevice
    showEarlyUpgradePenaltyAmount
    showReplacementNewDeviceSelectionFlow
  }
`
